import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowDown as falArrowDown } from '@fortawesome/pro-light-svg-icons/faArrowDown'
import { faArrowRightLong as falArrowRightLong } from '@fortawesome/pro-light-svg-icons/faArrowRightLong'
import { faComments as falComments } from '@fortawesome/pro-light-svg-icons/faComments'
import { faEnvelope as falEnvelope } from '@fortawesome/pro-light-svg-icons/faEnvelope'
import { faLightbulbOn as falLightbulbOn } from '@fortawesome/pro-light-svg-icons/faLightbulbOn'
import { faLink as falLink } from '@fortawesome/pro-light-svg-icons/faLink'
import { faSquare as falSquare } from '@fortawesome/pro-light-svg-icons/faSquare'
import { faSquareCheck as falSquareCheck } from '@fortawesome/pro-light-svg-icons/faSquareCheck'
import { faXmark as falXmark } from '@fortawesome/pro-light-svg-icons/faXmark'
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck'
import { faCircleTrash as fatCircleTrash } from '@fortawesome/pro-thin-svg-icons/faCircleTrash'
import { faClock as fatClock } from '@fortawesome/pro-thin-svg-icons/faClock'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  falComments,
  falEnvelope,
  falLightbulbOn,
  fatCircleTrash,
  fatClock,
  falXmark,
  falLink,
  falArrowRightLong,
  falArrowDown,
  falSquareCheck,
  falSquare,
  faCheck,
)

export default FontAwesomeIcon
